import { api } from 'api'

export const sendCustomerInvite = async (phone: string) => {
    await api.user.inviteClient(phone)
}
